import { render, staticRenderFns } from "./BrandsSelector.vue?vue&type=template&id=40c9bfdf&"
import script from "./BrandsSelector.vue?vue&type=script&lang=js&"
export * from "./BrandsSelector.vue?vue&type=script&lang=js&"
import style0 from "./BrandsSelector.vue?vue&type=style&index=0&id=40c9bfdf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListTile } from 'vuetify/lib/components/VList';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAutocomplete,VListTile,VSlideXTransition})
